import classnames from "classnames";
import React, { type FC, useCallback, useEffect, useState } from "react";
import LineItemsRuleSeverityFilter from "src/components/Pages/DocumentInbound/Tabs/DocumentItems/DocumentItemsTable/LineItemsRuleSeverityFilter";
import publishMetric, { MetricAction } from "src/metrics";
import styles from "src/styles.module.scss";

export interface MismatchTableFilterBarProps {
  mismatchRowData: Array<any>;
  setFilteredMismatchRowData: (rowData: any) => void;
}

const MismatchTableFilterBar: FC<MismatchTableFilterBarProps> = ({
  mismatchRowData,
  setFilteredMismatchRowData,
}) => {
  const [selectedSeverities, setSelectedSeverities] = useState<Array<string>>(
    []
  );

  const handleSetFilter = useCallback(() => {
    const filtered = mismatchRowData.filter((item) =>
      selectedSeverities.includes(item.ruleSeverity)
    );
    setFilteredMismatchRowData(filtered);
  }, [mismatchRowData, selectedSeverities, setFilteredMismatchRowData]);

  const handleClearFilter = useCallback(() => {
    setFilteredMismatchRowData(mismatchRowData);
  }, [mismatchRowData, setFilteredMismatchRowData]);

  useEffect(() => {
    if (selectedSeverities.length) {
      handleSetFilter();
    } else {
      handleClearFilter();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSeverities]);

  return (
    <div
      className={classnames(
        styles.flex,
        styles.flex_direction_row,
        styles.flex_nowrap,
        styles.align_items_center
      )}
    >
      <LineItemsRuleSeverityFilter
        onChange={setSelectedSeverities}
        metricsPublisher={() =>
          publishMetric(MetricAction.MISMATCH_TAB_FILTER_RULE_SEVERITY_CLICK)
        }
      />
    </div>
  );
};

export default MismatchTableFilterBar;
